<template>
	<div class="skfaceios_help">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">使用说明</h1>
		<h3 class="doc_main_h3">
			SKFace-iOS SDK 使用前须知	
		</h3>
		<p class="doc_main_p">1.到盛开人工智能开放平台<a href="https://www.sk-ai.com/">（https://www.sk-ai.com/）</a>注册企业账号。</p>
		<p class="doc_main_p">2.注册应用，填写平台信息、选择使用“SKFaceSDK”离线SDK。</p>
		<p class="doc_main_p">3.按接口说明文档使用该SDK。</p>
		<h3 class="doc_main_h3">
			使用说明	
		</h3>
		
		<p class="doc_main_p">1.SKFaceSDK 文件夹下为 SDK，请将 SKFaceSDK 文件夹添加到工程。</p>
		<p class="doc_main_p">2.添加 Accelerate.framework。</p>
		<p class="doc_main_p">3.在使用 SDK 类的后缀名改为.mm，也可以单独封装一个.mm 类调用 SDK(推荐后者)。</p>
		<p class="doc_main_p">4.SKFaceDemo 为 Demo 工程源码，可作为集成 SDK 的参考。</p>
		<p class="doc_main_p">5.接口调用请参考说明文档“SKFace-iOS 接口说明.pdf ”。</p>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../components/documentTitleBar';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFace-iOS','使用说明'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../less/index.less';
	.skfaceios_help{
	}
		a:hover{
		color:#00a0e9;
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfaceios/skfaceiosHelp.vue